import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import '../../services/GlobalVariables'
import axios from 'axios'

const API_URL = global.SET_API_URL + 'salary/'

const initialState = {
    salarySheet: [],
    departments: [],
    grandTotals: {},
    salaryExists: false,
    existingRecordsCount: 0,
    isLoading: false,
    isError: false,
    isSuccess: false,
    message: "",
    periodLocked: false,
    lockMessage: ""
}

export const getSalary = createAsyncThunk('sal/gs', async (dateData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'getSalary', dateData)
        console.log(result.data)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const saveSalarySheet = createAsyncThunk('sal/saveSalarySheet', async (salaryData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'saveSalarySheet', salaryData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const checkSalaryExists = createAsyncThunk('sal/checkSalaryExists', async (period, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'checkSalaryExists', period)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const deleteSalarySheet = createAsyncThunk('sal/deleteSalarySheet', async (period, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'deleteSalarySheet', period)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const checkPeriodLock = createAsyncThunk('sal/checkPeriodLock', async (periodData, thunkAPI) => {
    try {
        const result = await axios.post(API_URL + 'checkPeriodLock', periodData)
        return result.data
    } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        return thunkAPI.rejectWithValue(message)
    }
})

export const menuSlice = createSlice({
    name: 'sal',
    initialState,
    reducers: {
        reset: (state) => {
            state.salarySheet = []
            state.isLoading = false
            state.isError = false
            state.isSuccess = false
            state.message = ""
        }

    },
    extraReducers: (builder) => {
        builder
            .addCase(getSalary.pending, (state) => {
                state.isLoading = true
            })
            .addCase(getSalary.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.salarySheet = action.payload.salarySheet
                if (action.payload.otherData.departments) state.departments = action.payload.otherData.departments
                if (action.payload.otherData.grandTotals) state.grandTotals = action.payload.otherData.grandTotals

            })
            .addCase(getSalary.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
                state.salarySheet = []
            })
            .addCase(saveSalarySheet.pending, (state) => {
                state.isLoading = true
                state.isError = false
                state.message = ""
            })
            .addCase(saveSalarySheet.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.message = action.payload.message
                state.salaryExists = true
                state.existingRecordsCount = action.payload.recordsCount || state.existingRecordsCount
            })
            .addCase(saveSalarySheet.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(checkSalaryExists.pending, (state) => {
                state.isLoading = true
            })
            .addCase(checkSalaryExists.fulfilled, (state, action) => {
                state.isLoading = false
                state.salaryExists = action.payload.exists
                state.existingRecordsCount = action.payload.recordsCount
                if (!action.payload.exists) {
                    state.salarySheet = []
                    state.departments = []
                    state.grandTotals = {}
                }
            })
            .addCase(checkSalaryExists.rejected, (state, action) => {
                state.isLoading = false
                state.salaryExists = false
            })
            .addCase(deleteSalarySheet.pending, (state) => {
                state.isLoading = true
                state.isError = false
                state.message = ""
            })
            .addCase(deleteSalarySheet.fulfilled, (state, action) => {
                state.isLoading = false
                state.isSuccess = true
                state.message = action.payload.message
                state.salaryExists = false
                state.existingRecordsCount = 0
                state.salarySheet = []
                state.departments = []
                state.grandTotals = {}
            })
            .addCase(deleteSalarySheet.rejected, (state, action) => {
                state.isLoading = false
                state.isError = true
                state.message = action.payload
            })
            .addCase(checkPeriodLock.pending, (state) => {
                state.isLoading = true
            })
            .addCase(checkPeriodLock.fulfilled, (state, action) => {
                state.isLoading = false
                state.periodLocked = action.payload.isLocked
                state.lockMessage = action.payload.message
            })
            .addCase(checkPeriodLock.rejected, (state, action) => {
                state.isLoading = false
                state.periodLocked = false
                state.lockMessage = ""
            })
    }
})

export const { reset } = menuSlice.actions

export default menuSlice.reducer
